import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TaskReorderComponent } from './task-reorder.component';
import { SharedModule } from 'app/shared/shared.module';



@NgModule({
  declarations: [
    TaskReorderComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [
    TaskReorderComponent
  ]
})
export class TaskReorderModule { }
